import { render } from "./PurchasePaytModal.vue?vue&type=template&id=7bd6fb46&ts=true"
import script from "./PurchasePaytModal.vue?vue&type=script&lang=ts"
export * from "./PurchasePaytModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__